import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Login } from './components/auth/Login';
import { ChangePassword } from './components/auth/ChangePassword';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Header } from './components/layout/Header';
import { Dashboard } from './pages/Dashboard';
import { Unauthorized } from './pages/Unauthorized';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { PractitionerManagement } from './pages/admin/PractitionerManagement';
import { ModuleManagement } from './pages/admin/ModuleManagement';
import { ExamManagement } from './pages/admin/ExamManagement';
import { AssignmentManagement } from './pages/admin/AssignmentManagement';
import { SMTPConfiguration } from './pages/admin/SMTPConfiguration';
import { AuditLogs } from './pages/admin/AuditLogs';
import { TrainingDetail } from './pages/practitioner/TrainingDetail';
import { ContentViewer } from './pages/practitioner/ContentViewer';
import { ExamTaking } from './pages/practitioner/ExamTaking';
import { Certificates } from './pages/practitioner/Certificates';
import { ProfileSettings } from './pages/ProfileSettings';
import { UserRole } from './types/auth';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Header />
          
          <main className="max-w-7xl mx-auto py-4 px-4 sm:py-6 sm:px-6 lg:px-8">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <ProfileSettings />
                  </ProtectedRoute>
                }
              />
              
              {/* Admin Routes */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/practitioners"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <PractitionerManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/modules"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <ModuleManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/exams"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <ExamManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/exams/:moduleId"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <ExamManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/assignments"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <AssignmentManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/smtp"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <SMTPConfiguration />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/audit"
                element={
                  <ProtectedRoute requiredRole={UserRole.ADMINISTRATOR}>
                    <AuditLogs />
                  </ProtectedRoute>
                }
              />
              
              {/* Practitioner Routes */}
              <Route
                path="/training/:assignmentId"
                element={
                  <ProtectedRoute requiredRole={UserRole.PRACTITIONER}>
                    <TrainingDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/training/:assignmentId/content"
                element={
                  <ProtectedRoute requiredRole={UserRole.PRACTITIONER}>
                    <ContentViewer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/training/:assignmentId/exam"
                element={
                  <ProtectedRoute requiredRole={UserRole.PRACTITIONER}>
                    <ExamTaking />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/certificates"
                element={
                  <ProtectedRoute requiredRole={UserRole.PRACTITIONER}>
                    <Certificates />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;